import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({ settings: null, loading: true, refresh: () => {}, patch: () => {} });

const FALLBACK = {
  brand_name: "Meguiar's İzmit",
  tagline: "Kocaeli'nin Premium Araç Koruma Merkezi",
  phone: "0539 231 74 95",
  phone_intl: "+905392317495",
  whatsapp: "+905392317495",
  whatsapp_default_message: "Merhaba, araç bakım ve koruma hizmetleriniz hakkında bilgi almak istiyorum.",
  address: "MARS KOCAELİ İş ve Yaşam Merkezi, Yahyakaptan, Elzem Sk. No:54, 41050 İzmit/Kocaeli",
  maps_link: "https://www.google.com/maps/dir/?api=1&destination=MARS+KOCAEL%C4%B0+Elzem+Sk.+No%3A54+%C4%B0zmit+Kocaeli",
  working_hours: "Pazartesi - Cumartesi: 09:00 - 19:00",
  maintenance_mode: false,
  maintenance_title: "Sitemiz Yenileniyor",
  maintenance_message:
    "Meguiar's İzmit deneyimini daha güçlü, hızlı ve premium hale getirmek için web sitemizi güncelliyoruz. Bu süreçte randevu ve bilgi için bize WhatsApp veya telefon üzerinden ulaşabilirsiniz.",
  maintenance_show_whatsapp: true,
  maintenance_show_phone: true,
  maintenance_show_directions: true,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(
    () =>
      api
        .get("/settings")
        .then(({ data }) => {
          if (data && Object.keys(data).length) setSettings({ ...FALLBACK, ...data });
        })
        .catch(() => {}),
    []
  );

  const patch = useCallback((partial) => setSettings((s) => ({ ...s, ...partial })), []);

  useEffect(() => {
    let active = true;
    api
      .get("/settings")
      .then(({ data }) => {
        if (active && data && Object.keys(data).length) setSettings({ ...FALLBACK, ...data });
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, patch }}>{children}</SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext).settings;
}

export function useSettingsCtx() {
  return useContext(SettingsContext);
}
